import { render, staticRenderFns } from "./dom.vue?vue&type=template&id=3a797265&scoped=true"
import script from "./dom.vue?vue&type=script&lang=js"
export * from "./dom.vue?vue&type=script&lang=js"
import style0 from "./dom.vue?vue&type=style&index=0&id=3a797265&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a797265",
  null
  
)

export default component.exports